import Admin from '@/models/bread/Admin/questionSetQuestion'

export default {
  key:'Question Set Question',
  name:{
    singular:'Question Set Question',
    plural:'Question Set Questions',
  },
  parents:[
    //
  ],
  Admin:Admin,
  Moderator:false,
  Teacher:false,
}